export function toOptions(objects, nameMapFunction) {
    return !objects ? [] : objects.map(obj => {
        return {
            key: obj.id,
            value: obj.id,
            text: nameMapFunction ? nameMapFunction(obj): obj.name,
        };
    });
}